import React from 'react';
import classnames from 'classnames';
import styles from './checkbox.scss';

type Props = React.InputHTMLAttributes<HTMLInputElement> & {
  indeterminate: boolean,
  id: string,
  className?: string,
}

export default function Checkbox({ id, className = '', ...rest }: Props) {
  const input: React.RefObject<HTMLInputElement> = React.useRef(null);

  const handleKeyPress = React.useCallback((evt) => {
    if (evt.key === ' ') {
      evt.preventDefault();
      input.current!.click();
    }
  }, []);

  return (
    <React.Fragment>
      <input
        id={id}
        ref={input}
        className={styles.checkbox}
        type="checkbox"
        {...rest} />
      <label
        tabIndex={0}
        className={classnames(styles.label, className)}
        onKeyPress={handleKeyPress}
        htmlFor={id} />
    </React.Fragment>
  );
}
